<template>
  <div class="pageContent">
    <!-- <div class="hosName">天津大学新城医院</div> -->
    <img src="../../../assets/tianjin.jpg" alt="Login logo" class="loginLogo" />
    <div class="ourterTitle">姓名/手机号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value30000004.name30000004"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value30000004.value1"
          placeholder="请输入手机号"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      rules: true,
      value30000004: {
        name30000004: "",
        value1: "",
      },
    };
  },
  methods: {
    inputFn() {
      if (this.value30000004.name30000004 != "" && this.value30000004.value1 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value30000004", JSON.stringify(this.value30000004));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name30000004")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  background: linear-gradient(to bottom, #ffffff, #efefef);
  .loginLogo {
    height: auto;
    width: 260px;
  }
  .IDNumber .van-field{
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1)!important; /* 水平偏移 垂直偏移 模糊半径 颜色 */
  }
  .hosName {
    // font-size: 20px;
    // // padding: 10px 0;
    // font-weight: 800;

    display: block;
    width: 100%;
    font-size: 30px;
    color: rgb(164, 25, 16);
    // margin-top: 35px;
    padding: 65px 0 10px;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
